import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import "./popupbox.css";
import { useNavigate } from "react-router-dom";
import { SEND_API } from "../../utils/APIs";
import { RECAPTCHA_SITEKEY } from "../../utils/config";

function Popupboxx({ isOpen, onClose }) {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "Course Enquiry for Azure",
    message: "",
  });

  const [captchaValue, setCaptchaValue] = useState(null);
  const [responseMsg, setResponseMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!captchaValue) {
      alert("Please complete the CAPTCHA");
      return;
    }

    setIsLoading(true);

    const formDataObj = new FormData();
    formDataObj.append("name", formData.name);
    formDataObj.append("email", formData.email);
    formDataObj.append("phone", formData.phone);
    formDataObj.append("subject", formData.subject);
    formDataObj.append("message", formData.message);

    // For backend validation
    formDataObj.append("g-recaptcha-response", captchaValue);

    try {
      const response = await fetch(`${SEND_API}`, {
        method: "POST",
        body: formDataObj,
      });

      const result = await response.text();
      console.log("Server Response:", result);

      // Check for ANY type of success message
      if (result.toLowerCase().includes("success")) {
        // Reset form
        setFormData({
          name: "",
          email: "",
          phone: "",
          subject: "Course Enquiry for Azure",
          message: "",
        });

        setCaptchaValue(null);

        onClose(); // Close popup

        // Redirect
        navigate("/azure-course-in-chennai/thank-you");

      } else {
        setResponseMsg(result);
      }

    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="popup-overlay" onClick={onClose}></div>

      <div className="popup-form">
        <span className="close-btn" onClick={onClose}>
          &times;
        </span>

        <h2 className="popup-title">Get in Touch</h2>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            required
            value={formData.name}
            onChange={handleChange}
          />

          <input
            type="email"
            name="email"
            placeholder="Your Email"
            required
            value={formData.email}
            onChange={handleChange}
          />

          <input
            type="tel"
            name="phone"
            placeholder="Your Phone"
            required
            maxLength={10}
            value={formData.phone}
            onChange={handleChange}
          />

          <textarea
            name="message"
            rows="4"
            placeholder="Your Message"
            required
            value={formData.message}
            onChange={handleChange}
          ></textarea>

          <ReCAPTCHA
            sitekey={RECAPTCHA_SITEKEY}
            onChange={(value) => setCaptchaValue(value)}
            className="captcha-box"
          />
          <div className="center-button-name">
            <button
              className="download-btn"
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? "Sending..." : "Send Message"}
            </button>
          </div>
        </form>

        {responseMsg && <p className="response-msg">{responseMsg}</p>}
      </div>
    </>
  );
}

export default Popupboxx;
